import { Fragment } from "react";
import { Skeleton } from "@/shared/ui";
import { IMPORT_SECTIONS } from "../consts";

export default function ImportWorkerPageSkeleton() {
  return (
    <section className="flex-1 min-w-0">
      <div className="mb-7 flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke">
        <Skeleton height={32} width={280} />
        <Skeleton height={40} width={170} borderRadius={12} />
      </div>

      <div className="p-7 rounded-[28px] surface-base-fill flex items-start justify-between gap-7">
        <div className="w-xs">
          <aside className="relative flex gap-2">
            <div className="flex flex-col mt-1.5 gap-1.5 items-center">
              {IMPORT_SECTIONS.map((section, index) => (
                <Fragment key={section.id}>
                  <Skeleton circle width={24} height={24} />
                  {index < IMPORT_SECTIONS.length - 1 && <Skeleton height={6} width={1} />}
                </Fragment>
              ))}
            </div>

            <div className="flex flex-col gap-0.5 w-full">
              {IMPORT_SECTIONS.map((section) => (
                <div key={section.id} className="px-3 py-2.5 radius-xs flex items-center gap-2">
                  <Skeleton width={16} height={16} />
                  <Skeleton height={20} width={140} />
                </div>
              ))}
            </div>
          </aside>
        </div>

        <div className="flex-1 p-7 radius-lg border surface-base-stroke flex flex-col justify-between">
          <div className="flex flex-col gap-7">
            <Skeleton height={28} width={200} />

            <div className="grid grid-cols-2 gap-y-4 gap-x-3">
              {Array.from({ length: 8 }).map((_, index) => (
                <div key={index} className="flex flex-col gap-1">
                  <Skeleton height={16} width={140} />
                  <Skeleton height={44} />
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 flex justify-end items-center gap-3">
            <Skeleton height={44} width={140} borderRadius={12} />
          </div>
        </div>
      </div>
    </section>
  );
}
